module.exports = __webpack_public_path__ + "img/battery_2classic.5e2c40b9.png";